import { EmptyContent } from "../../components/EmptyContent";
import { ScreenLayout } from "../../components/ScreenLayout";
import { Spinner } from "../../mobile/components/common";
import { TicketList } from "../../components/Ticket/TicketList";
import { useHistoricTickets, useTicketsPagination } from "state/tickets/hooks";
import { ErrorMessage } from "views/components/Message";
import { FlatButton } from "views/components/FlatButton";
import { Pagination } from "antd";
import { Spacer } from "views/components/common/Spacer";
import React, { useDispatch } from "reactn";

const TicketsScreen = () => {
	const [
		tickets,
		currentPage,
		setCurrentPage,
		total,
		loading,
		error,
	] = useTicketsPagination();

	return (
		<ScreenLayout
			title="Mi Historial de Tickets"
			description="Tickets que ya han sido atendidos o que fueron emitidos hace más de 6 horas:"
			contentAligned={true}
		>
			{error && <ErrorMessage error={error} />}
			{!loading && !tickets.length && (
				<EmptyContent description="No hay registro de tickets aún..."></EmptyContent>
			)}
			{loading && <Spinner full></Spinner>}
			{!loading && !!tickets.length && (
				<TicketList
					referrer="tickets-history-screen"
					tickets={tickets}
				/>
			)}
			{!!tickets.length && (
				<>
					<Spacer rows={1} />
					<Pagination
						current={currentPage}
						total={total ? total : 10}
						onChange={setCurrentPage}
					/>
				</>
			)}
		</ScreenLayout>
	);
};

export default TicketsScreen;
